import { Capacitor } from "@capacitor/core";
import { shutdown } from "@intercom/messenger-js-sdk";
import { IonItem, IonItemDivider, IonItemGroup, IonLabel, IonList, IonText } from "@ionic/react";
import { useAuth } from "pages";
import { MdKey, MdPeople, MdRequestQuote } from "react-icons/md";
import { Link, useHistory } from "react-router-dom";
import { createBillingPath } from "routes/routeData";
import { AppBuildVersionInfo, Icon, useFeatureFlags } from "swing-components";
import { openHelpCenter } from "swing-utils";
import { getFeatureFlags } from "utils/featureFlags";

import { BUILD_SHA, BUILD_VER, translate, useIntercomMessenger } from "~utils";

export function MorePage() {
  const { signOut, userInfo } = useAuth();
  const history = useHistory();
  const { BILLING_PAGE } = getFeatureFlags(userInfo);
  const isNative = Capacitor.isNativePlatform();
  const { flags } = useFeatureFlags();
  const { subMap } = flags;

  const { openIntercomMessenger } = useIntercomMessenger();

  const BillingPortalLink = isNative ? (
    <IonItem disabled>
      <MdRequestQuote className="icon-2xl" />
      <IonLabel className="ion-padding-start">
        <IonText>{translate("ROUTE_TABLE_VIEW_BILLING_PORTAL_DISABLED")}</IonText>
      </IonLabel>
    </IonItem>
  ) : (
    <Link to={createBillingPath()} className="swing-link">
      <IonItem>
        <MdRequestQuote className="icon-2xl" />
        <IonLabel className="ion-padding-start">
          <IonText>{translate("ROUTE_TABLE_VIEW_BILLING_PORTAL")}</IonText>
        </IonLabel>
      </IonItem>
    </Link>
  );

  return (
    <div className="mw-800">
      <IonList>
        <IonItemGroup className="ion-padding-bottom">
          <Link to="/schools" className="swing-link">
            <IonItem>
              <Icon name="School" />
              <IonLabel className="ion-padding-start">
                <IonText>{translate("SIDE_MENU_LABEL_SCHOOLS")}</IonText>
              </IonLabel>
            </IonItem>
          </Link>
          <IonItem button onClick={openHelpCenter}>
            <Icon name="Help" />
            <IonLabel className="ion-padding-start">
              <IonText>{translate("HELP_CENTER")}</IonText>
            </IonLabel>
          </IonItem>
          <IonItem button onClick={openIntercomMessenger}>
            <Icon name="Chat Bubble" />
            <IonLabel className="ion-padding-start">
              <IonText>{translate("CHAT_WITH_SUPPORT")}</IonText>
            </IonLabel>
          </IonItem>
          {BILLING_PAGE && BillingPortalLink}
          <IonItem
            button
            onClick={() => {
              // shutdown will be a noop if Intercom is not enabled
              shutdown();
              signOut({ history });
            }}
          >
            <Icon name="Logout" />
            <IonLabel className="ion-padding-start">
              <IonText>{translate("SIGN_OUT")}</IonText>
            </IonLabel>
          </IonItem>
        </IonItemGroup>
        {subMap && (
          <IonItemGroup>
            <IonItemDivider>Sub Locator</IonItemDivider>
            <Link to="/subMap" className="swing-link">
              <IonItem>
                <MdKey className="icon-2xl" />
                <IonLabel className="ion-padding-start">{translate("SUB_LOCATOR")}</IonLabel>
              </IonItem>
            </Link>
          </IonItemGroup>
        )}
        {userInfo.isSuperAdmin && (
          <IonItemGroup>
            <IonItemDivider>{translate("SUPERADMIN")}</IonItemDivider>
            <Link to="/waitlist" className="swing-link">
              <IonItem>
                <MdPeople className="icon-2xl" />
                <IonLabel className="ion-padding-start">
                  {translate("LABEL_ACTIVE_WAITLIST_REQUEST_INDEX_TAB")}
                </IonLabel>
              </IonItem>
            </Link>
          </IonItemGroup>
        )}
      </IonList>
      <AppBuildVersionInfo version={BUILD_VER} build={BUILD_SHA} />
    </div>
  );
}
